import { useRef, useEffect } from 'react'
import styles from './AppLayout.pcss'
import AppNavigationSidebar from '../AppNavigationSidebar'
import CalloutManager from '../CalloutManager/CalloutManager'
import ContentSelectionDrawer from 'routes/find/components/ContentSelectionDrawer'
import { Outlet } from 'react-router'
import { TrialWidget } from 'components/TrialWidget'

interface AppLayoutProps {
  hidden?: boolean
  blurred?: boolean
  hideSidebar?: boolean
}

export function AppLayout(props: AppLayoutProps) {
  const { hidden, blurred, hideSidebar } = props
  const scrollingElement = useRef<HTMLDivElement>(null)

  // Scroll down/up one screen on Spacebar (Shift + Spacebar) press
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return
      }
      if (event.key === ' ' && scrollingElement.current) {
        const scrollAmount = event.shiftKey ? -window.innerHeight : window.innerHeight
        scrollingElement.current.scrollBy({
          top: scrollAmount,
          behavior: 'smooth'
        })
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  return (
    <section className={`${styles['app-container']} ${blurred ? styles.blur : ''} ${hideSidebar ? styles['no-sb'] : ''}`}>
      <main className={styles.main} data-test="main" data-testid="main" ref={scrollingElement}>
        <div className={`${styles.layout} ${hidden ? styles.hidden : ''}`}>
          <div className={styles['side-panel']}>
            <AppNavigationSidebar />
          </div>
          <div className={styles.content}>
            <CalloutManager />
            <ContentSelectionDrawer />
            <Outlet />
          </div>
        </div>
      </main>
      <TrialWidget />
    </section>
  )
}
